export { DoctorCard } from './ui';

export { DoctorAvatar } from './ui/DoctorAvatar';
export { DoctorTitle } from './ui/DoctorTitle';
export { Discount } from './ui/Discount';
export { DoctorPrice } from './ui/DoctorPrice';
